import type { BeatLineViteConfig } from '../api/types';
import { patchShellDataset } from './bootstrap';
import bundledGameShellHtml from '../golden/game-shell.html?raw';

function executeInlineScripts(container: HTMLElement | Element): void {
  const scripts = [...container.querySelectorAll('script')];
  for (const oldScript of scripts) {
    const newScript = document.createElement('script');
    for (const attr of [...oldScript.attributes]) newScript.setAttribute(attr.name, attr.value);
    if (oldScript.src) {
      newScript.async = false;
      newScript.src = oldScript.src;
    } else {
      newScript.textContent = oldScript.textContent || '';
    }
    oldScript.parentNode?.replaceChild(newScript, oldScript);
  }
}

export async function renderFrontendOwnedShell(_config: BeatLineViteConfig): Promise<void> {
  const root = document.getElementById('beatline-vite-root') || document.body;
  if (root.querySelector('#beatline-app') || document.getElementById('beatline-app')) return;

  // C40: the game shell is bundled into the Vite/TypeScript runtime.
  // WordPress only supplies backend config/nonces; it no longer serves the frontend template.
  root.innerHTML = bundledGameShellHtml;
  executeInlineScripts(root);
  patchShellDataset(_config);
}
